import {APIError} from 'data/errors';
import {HttpStatusCode} from 'data/protocols/http';
import {HelpCenterEnum} from 'presentation/constants';
import {useNavigate} from 'react-router-dom';
import {useSendMessageMutation} from '../queries/useSendMessageMutation';

export function useSendMessage() {
	const navigate = useNavigate();

	const {
		mutate: handleSendMessage,
		isPending,
		reset: resetMutation,
		isError,
		isSuccess,
		data: sendMessageData,
		error,
	} = useSendMessageMutation();

	const openTimeoutErrorModal =
		isError && error instanceof APIError && error.statusCode === HttpStatusCode.badRequest;
	const openDefaultErrorModal = isError && !openTimeoutErrorModal;
	const openSuccessModal = isSuccess && !!sendMessageData;
	const protocolValue = sendMessageData?.Ds_registro ?? '';

	const handleBack = () => {
		navigate(HelpCenterEnum.HELP);
	};

	return {
		handleBack,
		handleSendMessage,
		isPending,
		resetMutation,
		openDefaultErrorModal,
		openTimeoutErrorModal,
		openSuccessModal,
		protocolValue,
	};
}
